module.exports = __webpack_public_path__ + "static/media/logo.412d8abf.png";